module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticStyle: {
      "padding": "1.5rem"
    }
  }, [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": "",
      "position": "is-centered"
    }
  }, [_c('b-switch', {
    model: {
      value: (_vm.indicator),
      callback: function($$v) {
        _vm.indicator = $$v
      },
      expression: "indicator"
    }
  }, [_c('strong', [_vm._v("Indicator")])]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": !_vm.indicator
    },
    model: {
      value: (_vm.indicatorBackground),
      callback: function($$v) {
        _vm.indicatorBackground = $$v
      },
      expression: "indicatorBackground"
    }
  }, [_vm._v("Background")]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": !_vm.indicator
    },
    model: {
      value: (_vm.indicatorInside),
      callback: function($$v) {
        _vm.indicatorInside = $$v
      },
      expression: "indicatorInside"
    }
  }, [_vm._v("Inside")])], 1), _c('br'), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": "",
      "position": "is-centered"
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Position",
      "disabled": !_vm.indicator
    }
  }, [_c('b-select', {
    model: {
      value: (_vm.indicatorPosition),
      callback: function($$v) {
        _vm.indicatorPosition = $$v
      },
      expression: "indicatorPosition"
    }
  }, [_c('option', {
    attrs: {
      "value": "is-bottom"
    }
  }, [_vm._v("is-bottom")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-top"
    }
  }, [_vm._v("is-top")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Mode"
    }
  }, [_c('b-field', [_c('b-radio-button', {
    attrs: {
      "native-value": "click",
      "disabled": !_vm.indicator
    },
    model: {
      value: (_vm.indicatorMode),
      callback: function($$v) {
        _vm.indicatorMode = $$v
      },
      expression: "indicatorMode"
    }
  }, [_c('span', [_vm._v("Click")])]), _vm._v(" "), _c('b-radio-button', {
    attrs: {
      "native-value": "hover",
      "disabled": !_vm.indicator
    },
    model: {
      value: (_vm.indicatorMode),
      callback: function($$v) {
        _vm.indicatorMode = $$v
      },
      expression: "indicatorMode"
    }
  }, [_c('span', [_vm._v("Hover")])])], 1)], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Style"
    }
  }, [_c('b-field', [_c('b-radio-button', {
    attrs: {
      "native-value": "is-boxs",
      "disabled": !_vm.indicator
    },
    model: {
      value: (_vm.indicatorStyle),
      callback: function($$v) {
        _vm.indicatorStyle = $$v
      },
      expression: "indicatorStyle"
    }
  }, [_c('span', [_vm._v("Boxs")])]), _vm._v(" "), _c('b-radio-button', {
    attrs: {
      "native-value": "is-dots",
      "disabled": !_vm.indicator
    },
    model: {
      value: (_vm.indicatorStyle),
      callback: function($$v) {
        _vm.indicatorStyle = $$v
      },
      expression: "indicatorStyle"
    }
  }, [_c('span', [_vm._v("Dots")])]), _vm._v(" "), _c('b-radio-button', {
    attrs: {
      "native-value": "is-lines",
      "disabled": !_vm.indicator
    },
    model: {
      value: (_vm.indicatorStyle),
      callback: function($$v) {
        _vm.indicatorStyle = $$v
      },
      expression: "indicatorStyle"
    }
  }, [_c('span', [_vm._v("Lines")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-carousel', {
    attrs: {
      "indicator": _vm.indicator,
      "indicator-background": _vm.indicatorBackground,
      "indicator-inside": _vm.indicatorInside,
      "indicator-mode": _vm.indicatorMode,
      "indicator-position": _vm.indicatorPosition,
      "indicator-style": _vm.indicatorStyle
    }
  }, _vm._l((_vm.carousels), function(carousel, i) {
    return _c('b-carousel-item', {
      key: i
    }, [_c('section', {
      class: ("hero is-medium is-" + (carousel.color))
    }, [_c('div', {
      staticClass: "hero-body has-text-centered"
    }, [_c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(carousel.title))])])])])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eed6cba"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/carousel/examples/ExIndicator.vue
// module id = 987
// module chunks = 3 164